import moment from 'moment';

const dateFormat = 'MMM D, YYYY';

/**
 * @param {import('moment').MomentInput} date
 * @param {string} format
 * @returns {string}
 */
export const momentFormat = (date, format) => moment(date).format(format);

/**
 * @param {import('moment').MomentInput} date
 * @returns {string}
 */
export const formatDate = date => momentFormat(date, dateFormat);

export const MONTH_NAMES = Array.from({ length: 12 }, (_, i) => new Date(2000, i).toLocaleString('en', { month: 'long' }));

/**
 * @param {Date | string | number} dateString
 * @returns {Date}
 */
export const dateZero = dateString => {
  const date = new Date(dateString);
  const zeroTime = date.toISOString().slice(0, -14); // Take off `T...Z`.
  return new Date(Number(zeroTime.split('-')[0]), Number(zeroTime.split('-')[1]) - 1, Number(zeroTime.split('-')[2]), 0, 0, 0);
};
